import { useState } from "react";
import IfThen from "./IfThen";
import { Toaster } from "react-hot-toast";
import SelectLanguage from "./SelectLanguage";

interface FooterProps {
    showAlertDummy?: boolean;
}
function Footer({showAlertDummy}: FooterProps) {    
    return (
        <div className="footer">

           
            {/* <IfThen condition={true}>
                <div className="position-fixed start-50 bottom-0 translate-middle-x w-50 zi-99 mb-3 bg-white">
                    <div className="card card-sm  alert alert-soft-danger mx-2 ">
                        <div className="card-body mx-auto">
                            <div className="" role="alert">
                                <div className="d-flex">
                                    <i className="bi bi-exclamation-triangle-fill" style={{ fontSize: '32px'}}></i>
                                    <div className="ms-3">
                                        La cuenta de WhatsApp con número +52 55 4433 2211 se encuentra sin conexión, contacta a tu administrador para más información
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </IfThen> */}
            <div className="row justify-content-between align-items-center">
                <div className="col">
                    <p className="fs-6 mb-0">HelpDesk <span className="d-none d-sm-inline-block">2023 Voices Comunicaciones Unificadas.</span></p>
                </div>


                <div className="col-auto">
                    <div className="d-flex justify-content-end">

                        <ul className="list-inline list-separator">
                            <li className="list-inline-item">

                                <SelectLanguage menuPlacement='top'/>

                            </li>
                        </ul>

                    </div>
                </div>

            </div>
        </div>
    )
}

export default Footer